<template>
  <div class="recommendation-boxes">
    <div class="recommendations-box left">
      <div class="content">
        <p class="heading">Tell us your budget
        </p>
        <p class="sub-heading"> You will get the best offers we have</p>
        <vue-slider v-model="sliderValue" tooltip="false" min="20000" :max="maxPrice" :process-style="{'backgroundImage': '-webkit-linear-gradient(left, #43284e, #a2233a)'}"></vue-slider>
      </div>
      <div class="action-content">
        <p class="title">
          your budget
        </p>
        <div class="budget-pricing">
          <p class="price">
            <span class="rs">Rs.</span>{{sliderValue}}
          </p>
          <button type="button" class="btn hallow-btn pull-left" @click="applyPriceFilter">
            Apply
          </button>
        </div>
      </div>
    </div>
    <div class="recommendations-box right">
      <div class="month-range">
        nov-feb
      </div>
      <div class="content">
        <p class="heading">Best time to visit goa</p>
        <p class="sub-heading"> 5 Days Average duration of stay</p>

      </div>
      <button type="button" class="btn hallow-btn pull-left">
        Find Package
      </button>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
export default {
  props: {
    maxPrice: {
      type: Number,
      required: false,
      default: function() {
        return 100000
      }
    }
  },
  components: {
    vueSlider
  },
  data: function() {
    return {
      sliderValue: 40000
    }
  },
  methods: {
    applyPriceFilter: function() {
      this.$emit('applyPriceFilter', {maxPrice: this.sliderValue})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/recommendation.vue